const zh = {
    "language": "中文",
    "/homePage": "首页",
    "/order": "我要下单",
    "/order/bookingSpace": "订舱明细",
    "/booking": "订舱查询",
    "/booking/bookingSpace": "订舱明细",
    "/billInfo": "提单信息",
    "/billOfLading": "提单查询",
    "/billOfLading/ladingDetails": "提单明细",
    "/billOfLading/ladingPreview": "提单预览",
    "/spliteBill": "拆单",
    "/combineBill": "并单",
    "/spliteAndCombine": "拆并单",
    "/track": "跟踪",
    "/cargoTrack": "货物跟踪",
    "/repairTrack": "修箱报价查询",
    "/freeTime": "FreeTime查询",
    "/equipment": "箱管",
    "/repair": "修箱",
    "/equipment/repair/estimate": "修箱估价单",
    "/estimate/estimateDetails": "修箱估价单明细",
    "/equipment/repair/thirdPartyCharge": "第三方收退费",
    "/equipment/demurrageRate": "滞箱费费率",
    "/userCenter":"用户中心",
    "/personalInfo":"个人信息",
    "/reconciliation": "对账",
    "/confirmFreight": "费用查询",
    "/billsManagement": "对账单管理",
    "/billsDetails": "对账单明细",
    "/invoiceApplication": "发票管理",
    "/invoiceDetails": "发票申请明细",
    "common": {
        "downloadButton": "下 载",
        "searchButton": "查 询",
        "resetButton": "重 置",
        "detail": "明细",
        "viewDetails": "查看明细",
        "newButton": "新建",
        "preViewButton": "预览",
        "editButton": "编辑",
        "detailsButton": "明细",
        "bookingButton": "订舱",
        "addButton": "增加",
        "addButton2": "新 增",
        "appendButton": "追 加",
        "copyNewButton": "拷贝新增",
        "deleteButton": "删除",
        "cancelButton": "取消",
        "cancelButton2": "取 消",
        "saveBtn": "保存",
        "skipBtn": "跳过",
        "selectInverse": "反选",
        "selectAll": "全选",
        "operateColumn": "操作",
        "menuColumn": "菜单",
        "exportTableData": "导出数据",
        "cardView": "卡片",
        "tableView": "表格",
        "saveButton": "保存草稿",
        "saveAndSendButton": "保存并发送船公司",
        "sendButton": "发送船公司",
        "SODownloadButton": "S/O下载",
        "SOBatchDownloadButton": "S/O批量下载",
        "BookingEdiImportBtnClick":"订舱EDI报文导入",
        "BookingEdiInstructBtnClick":"订舱EDI报文说明下载",
        "PLDownloadButton": "南沙提箱单下载",
        "PLBatchDownloadButton": "南沙提箱单批量下载",
        "blBatchDownload": "提单批量下载",
        "BatchDownloadPreviewFormatting":"批量下载预览格式件",
        "blDownload": "提单下载",
        "Preview":"确认件预览",
        "guaranteeUpload": "保函上传",
        "historyButton": "查看历史",
        "returnButton": "返回",
        "findButton": "搜 索",
        "closeButton": "关 闭",
        "confirmButton": "确认",
        "okButton": "确定",
        "okButton2": "确 定",
        "ExcelDownloadButton": "EXCEL导入模板下载",
        "ExceluploadButton": "EXCEL导入",
        "tips": "提示",
        "noData": "暂无数据",
        "noData2": "抱歉,暂无数据!",
        "pleaseConfirm": "请确认",
        "pleaseSelect": "请选择",
        "pleaseEnter": "请输入",
        "autoGenerate": "订舱确认后系统自动生成",
        "multiBlNoEnter": "请输入提单号，多个提单号之间请用逗号(,)分隔",
        "multiSOANoEnter": "请输入对账单号，多个对账单号之间请用逗号(,)分隔",
        "pleaseEnterContent": "请输入内容",
        "pleaseEnterContent2": "请输入内容,单行可输入的最大字符个数为35",
        "pleaseSelectDate": "请选择日期",
        "pleaseSelectSoDownloadTemplate": "请选择S/O下载模板：",
        "yes": "是",
        "no": "否",
        "trackSearchButton": "货物跟踪查询",
        "total": "共?条",
        "tooLong": "字符长度超过限制!",
        "row:": "第{0}行：",
        "blDownloadTooptip": "BL No.?已生成过提单,点击\"下载\",将下载之前生成的提单,点击\"重新下载\",将根据最新数据重新生成提单PDF并下载,请选择",
        "selectFiles": "选取文件",
        "uploadFiles": "上传文件",
        "laterUploadFiles":"补充文件上传",
        "guaranteeUploadTip": "只能上传*.pdf,*.png,*.jpg,*.jpeg文件，最多支持上传5个文件，单个文件大小不能超过5M",
        "uploadSIInfo": "SI信息上传",
        "guaranteeUnSubmit": "保函未提交",
        "guaranteeSubmit": "保函已提交",
        "guaranteeUnApproved": "未审核",
        "guaranteeApproving": "审核中",
        "guaranteeApproved": "审核通过",
        "guaranteeRejected": "审核未通过，请重新提交",
        "operation": "操作",
        "viewButton": "查看",
        "dragUploadTips1": "将文件拖到此处，或",
        "dragUploadTips2": "点击选择文件",
        "excelTemplateDL": "Excel导入模板下载",
        "validateSucceed": "校验成功！",
        "uploadConfirm": "是否确认上传？",
        "uploadSucceed": "上传成功！",
        "uploaded": "已上传",
        "unuploaded": "未上传",
        "committing": "提交中，请稍候...",
        "uploading": "上传中，请稍候...",
        "totalDisplay": "共{num}条",
        "deleteFail": "删除失败",
        "deleteSuccess":"删除成功!",
        "submitSuccess":"提交成功！",
        "close":"关闭",
        "menuHide": "隐藏菜单",
        "menuShow": "显示菜单",
        "backAuto": "本页面将自动关闭...",
        "noPermission": "暂无操作权限",
        "noFuncPermission": "抱歉，您的账号暂时无权访问此页面，请联系中谷客服人员开通权限",
        "batch":"批量操作",
        "uploadVgm":"VGM上传",
        "batchUploadVgm":"批量VGM上传",
        "confirm":"确认",
        "errorTip":"存在VGM数据校验未通过",
        "unknownError":"未知错误",
        "otherLanguageChars":"禁止输入特殊符号或除中文、英文之外的其他语言字符",
        "enAndNumSupported":"仅支持输入英文字母(A-Z)及数字(0-9)",
        "chineseChars":"禁止输入中文汉字",
        "chinesePunctuation":"禁止输入中文标点符号或中文空格",
        "overLength":"输入内容已超过最大长度限制（{maxLength}个字符）",
    },
    "billOfLading": {
        "siSubmitConfirm": "正式提交SI补料后，后续如需修改将收取改单费用，请确认信息无误后再提交",
        "iConfirmed": "我已确认",
    },
    "header": {
        "home": "首页",
        "order": "我要下单",
        "booking": "订舱查询",
        "lading": "提单信息",
        "billLading": "提单查询",
        "track": "跟踪",
        "cargoTrack": "货物跟踪",
        "repairTrack": "修箱报价查询",
        "freeTime": "FreeTime查询",
        "combineBill": "并单",
        "spliteBill": "拆单",
        "spliteAndCombine": "拆并单",
        "equipment": "箱管",
        "repair": "修箱",
        "estimate": "修箱估价单",
        "thirdPartyCharge": "第三方收退费",
        "userCenter":"用户中心",
        "personalInformation":"个人信息",
        "reconciliation": "对账",
        "otherLink": "中谷外贸网上订舱平台",
        "platformName": "中谷外贸电商",
        "logout": "退出登录",
        "nonLogin": "未登录",
        "confirmFreight": "费用查询",
        "billManagement": "对账单管理",
        "invoiceManagement": "发票管理",
    },
    /*登录页*/
    "homePage": {
        "login": "登录",
        "register": "立即注册",
        "forgetPassword": "忘记密码？",
        "welcome": "欢迎登录",
        "accountHolder":"请输入账号",
        "pwdHoder":"请输入密码"
    },
    /*我要下单页*/
    "order": {
        "placeOrder": "我要下单",
        "pol": "装货港",
        "pod": "卸货港",
        "polEtd": "装货港ETD",
        "podEta": "卸货港ETA",
        "note1": "使用说明",
        "note2": "显示以装港，卸港及ETD（A），服务类型为检索条件的船期。",
        "note3": "可从检索结果页面直接订舱。",
        "note4": "船期搜索",
        "note5": "请以装港，卸港及ETD（A），服务类型来检索船期。",
        "note6": "ETD，ETA和服务类型不为必选项。",
        "note7": "检索结果页面",
        "note8": "按日期顺序显示船期",
        "note9": "订舱",
        "note10": "点击订舱后，进入订舱编辑页面，录入订舱明细后，请点击保存并发送船公司",
        "note11": "相关职员会尽快和您联系",
        //船期表格
        "vesselName": "船名",
        "voyage": "航次",
        "polTerminalCode": "码头",
        "polEta": "POL ETA",
        "polEtd2": "POL ETD",
        "podEta2": "POD ETA",
        "underway": "航行时间",
        "serviceLineCode": "航线"
    },
    /*我要下单-订舱编辑页*/
    "bookingSpace": {
        "booking": {
            "bookingInfo": "订舱信息",
            "blInfo": "提单信息",
            "bkNo": "订舱号",
            "blNo": "提单号",
            "bookingStatus": "订舱状态",
            "blStatus": "提单状态",
            "bookingType": "订舱类型",
            "transportationTerms": "运输条款",
            "paidType": "付费方式",
            "agreementNo": "船开前协议号",
            "sales": "业务员",
            "applicantUnit": "询价单位"
        },
        "bl": {
            "blInfo": "提单信息",
            "blType": "提单类型",
            "deliveryDocumentMethod": "提单类型",
            "deliveryDocumentPlace": "签单地点",
            "deliveryDocumentQuantity": "签单份数",
            "paidPalce": "付费地点",
            "releaseStatus": "放单状态",
            "blReleaseFlag": "放货状态",
        },
        "shipperInfo": "发货人信息",
        "shipper": "发货人",
        "consigneeInfo": "收货人信息",
        "consignee": "收货人",
        "notify1Info": "通知人1信息",
        "notifier1": "通知人1",
        "notify2Info": "通知人2信息",
        "notifier2": "通知人2",
        "customer": {
            "address":"地址",
            "city":"城市名称",
            "provinceCode":"省份代码",
            "provinceName":"省份名称",
            "postCode":"邮政编码",
            "countryCode": "国家代码",
            "tel": "联系电话",
            "email": "邮件地址",
            "enterpriseCode": "企业代码",
            "note": "*以上地址,城市名称,省份代码,省份名称,邮政编码,国家代码、联系电话、邮件地址、企业代码输入信息在未勾选时将不会显示在提单上"
        },
        "place": {
            "placeInfo": "地点信息",
            "por": "接货地",
            "portFrom": "装货港",
            "portTo": "卸货港",
            "del": "目的地",
            "porName": "接货地描述",
            "polName": "装货港描述",
            "podName": "卸货港描述",
            "delName": "目的地描述",
            "portSelectionTipContent": "请您注意服务选择与填写规范，根据您的填写，系统将自动判断服务类型：\n• 填写 接货地 ≠ 装货港：视为委托我司安排外贸CCA支线运输，并确认相应运费。\n• 如需\"内转外\"服务：请填写 接货地 = 装货港，并主动联系我司口岸客服进行安排。",
        },
        "main": {
            "vesselInfo": "船舶信息",
            "vesselCode": "船名",
            "voyageNo": "航次",
            "voyageLeg": "航段",
            "saillingDate": "开航时间"
        },
        "branch": {
            "routingInfo": "前程运输",
            "branchVesselCode": "支线船名",
            "branchVoyageNo": "航次",
            "branchVoyageLeg": "航段",
            "branchSaillingDate": "预计开航日",
            "branchCarrier": "承运人",
            "note": " *前程运输航线为中谷内贸线时，支线承运人请选择“ZGI”"
        },
        "cargo": {
            "cargoInfo": "货物信息",
            "quantity": "件数",
            "grossWeight": "毛重(KG)",
            "netWeight": "净重(KG)",
            "cargoSize": "尺寸",
            "cargoDesc": "货描",
            "shippingMark": "唛头",
            "packageType": "包装类型",
            "packageDesc": "包装描述",
            "packageDescPlaceholder": "请选择包装类型",
            "hsCode": "HS CODE",
            "commodityCode": "品名代码",
            "commodityName": "品名名称",
            "packageTypeSearch": "包装类型代码",
            "packageDescSearch": "包装类型名称",
            "hscodeTips" :"*如果有多个HSCODE都需要填写。例如: 123154,242344,123465",
        },
        "preContainer": {
            "preContainerInfo": "订舱预配箱",
            "containerType": "箱型",
            "quantity": "数量",
            "cargoTypeCode": "货类"
        },
        "specialInfo": "特殊设置",
        "bkImos": {
            "bkImo": "危险品",
            "classType": "IMO Class",
            "unSeriseNo": "UN No.",
            "label": "Label",
            "packageDesc": "包装种类",
            "packageCode": "包装类型",
            "property": "运输品名",
            "componentDesc": "化学品名",
            "emergencySeq": "应急措施编号",
            "emergencyTelNo": "紧急联系",
            "quantity": "件数",
            "grossWeight": "毛重",
            "netWeight": "净重",
            "flashPoint": "闪点",
            "rateBase": "闪点单位",
            "isPolutionFlag": "是否海污"
        },
        "bkReefers": {
            "bkReefer": "冷箱信息",
            "rateBase": "单位",
            "temperature": "温度",
            "intakeNum": "通风口"
        },
        "bkSoc": "SOC",
        "bkAks": {
            "bkAk": "特种箱信息",
            "containerType": "箱型",
            "akLength": "长(cm)",
            "akWidth": "宽(cm)",
            "akHigth": "高(cm)",
            "akGrossWeight": "总重(kg)"
        },
        "other": {
            "otherInfo": "其他信息",
            "remark": "订舱备注",
            "siRemark": "提单备注",
            "rejectReason": "订舱拒绝",
            "guaranteeSubmissionStatus": "保函提交状态",
            "guaranteeReviewStatus":"保函审核状态",
            "reDownloadPrompt":"该提单已生成过提单,点击\"下载\",将下载之前生成的提单,点击\"重新下载\",将根据最新数据重新生成提单PDF并下载,请选择",
            "download": "下载",
            "reDownload": "重新下载",
            "downloadFailed":"下载失败",
            "committed" :"已提交",
            "uncommitted":"未提交",
            "pendingApproval":"审核中",
            "approved":"审核通过",
            "unApproved":"审核不通过",
            "downloaFailed1":"该提单尚未确认，不支持下载提单",
            "downloaFailed2":"guaranteeUpload.validate.wrongDeliveryDocumentMethod",
            "downloaFailed3":"该提单尚未提交保函或保函尚未审核通过，不支持下载提单",
            "downloaFailed4": "该提单当前已扣货，不支持下载提单",
            "downloaFailed5": "该提单当前尚未放单，不支持下载提单",
            "downloaFailed6":"该提单已签发，不支持下载提单",
            "tipsForUploadingFiles":"保函文件是否已全部添加?请一次性上传",
            "uploadFiles" : "上传文件",
            "bldownload" : "提单下载",
            "blReject":"提单拒绝"
        },
        "container": {
            "containerInfo": "集装箱信息",
            "containerNo": "箱号",
            "containerType": "箱型",
            "sealNo1": "铅封号1",
            "sealNo2": "铅封号2",
            "sealNo3": "铅封号3",
            "sealNo4": "铅封号4",
            "quantity": "件数",
            "weight": "毛重(KGS)",
            "containerWeight": "箱皮重(KGS)",
            "cntrSize": "体积(CBM)",
            "cargoTypeCode": "货类",
            "containerManager": "箱主",
            "cargoDesc": "货名",
            "hsCode": "HS CODE",
            "classType": "IMDG CLASS",
            "unSerialNo": "UN NO.",
            "reeferTemp": "温度",
            "operation": "操作",
            "validateFileTypeFailed": "上传失败！仅支持.xls，.xlsx格式的Excel文件上传"
        }
    },
    /*订舱查询/提单查询页*/
    "booking": {
        "bookingSearch": "订舱查询",
        "spliteSearch": "拆单查询",
        "combineSearch": "并单查询",
        "blSearch": "提单查询",
        "vesselCode": "船名",
        "vvl": "船名/航次",
        "vesselName": "船名",
        "voyage": "航次",
        "loadingPort": "装货港",
        "dischargePort": "卸货港",
        "sailingTimeStart": "开航时间从",
        "sailingTimeEnd": "开航时间到",
        "crateTimeStart": "创建时间从",
        "crateTimeEnd": "创建时间到",
        "bkNo": "订舱号",
        "blNo": "提单号",
        "bookingStatus": "订舱状态",
        "blStatus": "提单状态",
        "popover": {
            "no": "序号",
            "vessel": "船名",
            "vesselCode": "船舶代码",
            "vesselNameCn": "船舶名称",
            "vesselNameCN": "船中文名",
            "voyageNo": "航次",
            "voyageLeg": "航段"
        },
        /*舱单表格*/
        "no": "序号",
        "pol": "装货港",
        "polEtd": "ETD",
        "pod": "卸货港",
        "podEta": "ETA",
        "del": "目的港",
        "rejectReason": "订舱拒绝",
        "updatedDtmLoc": "修改时间",
        "remark": "备注",
        "guaranteeUpload": "保函上传",
        "guaranteeSubmissionStatus": "保函提交状态",
        "guaranteeReviewStatus": "保函审核状态",
        "guaranteeReviewedRemarks": "保函审核备注",
        "enclosurName": "保函名称",
        "uploadTime": "上传时间",
        "containerInfoType": "箱信息类型",
        "blTemplate": "预览模板",
        "blTemplateDL":"下载模板",
        "cargoDescOGSShow": "货描内容显示",
        "cntrOgsShow": "显示分箱件重尺",
        "EDIMessageImport":"EDI报文导入",
        "bookingInstruct":'【注】订舱EDI报文上传仅支持 *.txt,*.edi 格式的记事本文件；文件结构说明请点击“订舱EDI报文说明下载”按钮下载说明文件',
        "EDIMessageUpload":"EDI报文上传",
        "importResult":"导入结果",
        "billInstruct":'【注】提单EDI报文上传仅支持 *.txt,*.edi 格式的记事本文件；文件结构说明请点击“提单EDI报文说明下载”按钮下载说明文件"',
        "billEDIMessageImport":"提单EDI报文导入",
        "billEDIMessageInstructDownLoad":"提单EDI报文说明下载",
        "sumitSiInformation":"批量提交SI信息",
        "copyNewDialogTitle": " 请确认拷贝船期",
        "cancelCopyButton": "取消拷贝",
        "confirmCopyButton": "确认拷贝",
        "copyNewTips1" :"* 如果为同一航次下订舱信息的拷贝新增，可直接点击“确认拷贝”；",
        "copyNewTips2" :"* 如果为不同航次下订舱信息的拷贝新增，请先选中本次订舱的船期信息，再点击确认。",
        "containerTypeAndQuantity" :"箱型箱量",
    },
    /*提单预览/下载组件*/
    "blFormatSettings": {
        "previewMdoe": "预览",
        "downloadMode": "下载",
        "headerTitle": "提单-{previewBlNo} {mode}格式设置",
        "headerSubTitle-preview": "设置提单预览格式及需要展示的箱信息类型格式（支持实时预览）",
        "headerSubTitle-download": "请选择提单需要展示的箱信息类型格式",
        "currentSelected": "当前选中",
        "choosePreviewTemplate": "选择预览模板",
        "blConfimationTemplate": "（干线）提单确认件",
        "feederBlConfimationTemplate": "（支线）提单确认件",
        "lastBlConfimationTemplate": "（末程干线）提单确认件",
        "chooseContainerFormat": "选择箱信息类型",
        "containerNo": "箱号",
        "sealNo": "封号",
        "size": "尺寸",
        "quantity": "件数",
        "grossWeight": "毛重",
        "volume": "体积",
        "cargoDesc": "货名",
        "hsCode": "HS CODE",
        "tareWeight": "皮重",
        "containerType": "箱型",
        "ctnNo-sealNo-size": "箱号/封号/箱尺寸",
        "ctnNo-sealNo-size-jmt": "箱号/箱型/封号/件毛体",
        "ctnNo-sealNo-size-jmt-hm-hscode": "箱号/箱型/封号/件毛体/货名/HS CODE",
        "ctnNo-sealNo-size-vol": "箱号/封号/箱型/件毛皮体",
        "simpleContainerInfoTips": "提单中“Container and Seal No.”部分仅展示箱号、铅封号及箱尺寸信息，适用于只需要打印基础箱信息的情况",
        "completeContainerInfoTips": "提单中“Container and Seal No.”部分将展示完整的集装箱信息，包含箱号、铅封号、箱尺寸、件数、毛重及体积信息",
        "completeContainerInfoTips2": "提单中“Container and Seal No.”部分将展示完整的集装箱信息，包含箱号、铅封号、箱型、件数、毛重、皮重及体积信息",
        "specialContainerInfoTips": "提单中“Container and Seal No.”部分将展示完整的集装箱信息，包含箱号、铅封号、箱型、件数、毛重、皮重、体积、货名及HS CODE信息",
        "previewRefreshTips": "请点击预览按钮生成提单预览版式",
        "previewBtn": "预 览",
        "closeBtn": "关 闭",
        "cancelBtn": "取 消",
        "downloadBtn": "下 载",
        "cargoDescOptions": "货描显示内容设置（可选）",
        "cntrOgsShow": "显示分箱件重尺",
        "loadingTips": "正在加载报表...",
        "previewFailedTips": "预览生成失败",
        "blConfimationTemplateTips": "默认的提单预览格式，适用于大多数场景",
        "feederBlConfimationTemplateTips": "适用于中转提单仅需要显示大船信息的场景",
        "lastBlConfimationTemplateTips": "适用于中转提单需要同时显示驳船和大船信息的场景",
    },
    /*货物跟踪*/
    "cargoTrack": {
        "title": "中谷物流外贸货物跟踪查询",
        "billInfo": "提单信息",
        "blNo": "提单号",
        "por": "接货地",
        "pol": "装货港",
        "pod": "卸货港",
        "del": "目的地",
        "voyageInfo": "航次信息",
        "vesselName": "船名",
        "voyage": "航次",
        "portFromName": "装港",
        "departureTime": "离港时间",
        "portToName": "卸港",
        "arrivalTime": "到港时间",
        "containerInfo": "集装箱最新动态",
        "containerNo": "集装箱号",
        "containerType": "箱型",
        "latestDynamicDesc": "最新动态",
        "note": "所有货物跟踪信息仅供参考"
    },
    /*修箱报价查询*/
    "repairTrack": {
        "repairSearchButton": "修箱报价查询",
        "title": "中谷物流外贸修箱报价查询",
        "repairInfo": "修箱信息",
        "receiveAndRefund": "收退费信息",
        "estimateNo": "估价单号",
        "blNo": "提单号",
        "containerNo": "箱号",
        "repairCompany": "修箱公司名称",
        "repairPlace": "修理地点",
        "applyDate": "申请日期",
        "actualAmount": "修理金额",
        "currency": "币种",
        "factFinalDate": "完成日期",
    },
    /*拆单*/
    "spliteBill": {
        "no": "序号",
        "voyageSpliteSearch": "航次拆单查询",
        "cancelSpliteButton": "取消拆单",
        "queryHBLByVoyageButton": "分单查询",
        "newHBLButton": "新增分单",
        "saveHBLButton": "保存分单",
        "deleteHBLButton": "删除分单",
        "copyToHBLButton": "复制到分单",
        "VVL": "船名/航次",
        "vesselCode": "船舶代码",
        "vesselName": "船舶名称",
        "voyageNo": "航次",
        "bkNo": "订舱号",
        "blNo": "提单号",
        "billInfo": "舱单信息",
        "spliteCombinDesc": "拆/并",
        "voyageLeg": "航段",
        "pol": "装货港",
        "pod": "卸货港",
        "fwdDes": "订舱代理",
        "consigneeCode": "收货人",
        "consigneeName": "收货人名称",
        "shipperCode": "发货人",
        "shipperName": "发货人名称",
        "notify1Code": "通知人",
        "notify1Name": "通知人名称",
        "masterPreContainerInfo": "主单订舱预配箱信息",
        "containerType": "箱型代码",
        "quantity": "件数",
        "cargoTypeCode": "货物类型",
        "hblInfo": "分单信息",
        "cargoCommodityCode": "品名代码",
        "cargoCommodityName": "品名名称",
        "cargoShippingMark": "唛头",
        "cargoQuantity": "制单件数",
        "cargoGrossWeight": "制单重量",
        "cargoNetweight": "制单净重",
        "cargoSize": "制单尺寸",
        "hBLPreContainerInfo": "分单订舱预配箱信息",
        "containerTypeAndQuantity": "箱型箱量",
        "hBLSearch": "分单查询",
    },
    /*并单*/
    "combineBill": {
        "no": "序号",
        "voyageCombineSearch": "航次并单查询",
        "cancelCombineButton": "取消并单",
        "setBlNoForMBLButton": "设置当前提单为主单",
        "queryHBLByVoyageButton": "分单查询",
        "removeHBLButton": "移除分单",
        "VVL": "船名/航次",
        "vesselCode": "船舶代码",
        "vesselName": "船舶名称",
        "voyageNo": "航次",
        "bkNo": "订舱号",
        "blNo": "提单号",
        "pol": "装货港",
        "pod": "卸货港",
        "del": "目的港",
        "billInfo": "舱单信息",
        "consigneeCode": "收货人",
        "consigneeName": "收货人名称",
        "shipperCode": "发货人",
        "shipperName": "发货人名称",
        "notify1Code": "通知人",
        "notify1Name": "通知人名称",
        "cargoCommodityName": "品名名称",
        "cargoShippingMark": "唛头",
        "cargoQuantity": "制单件数",
        "cargoGrossWeight": "制单重量",
        "cargoSize": "制单尺寸",
        "transportationTerms": "运输条款",
        "masterPreContainerInfo": "主单订舱预配箱信息",
        "containerType": "箱型代码",
        "quantity": "件数",
        "cargoTypeCode": "货物类型",
        "hblInfo": "分单信息",
        "hBLPreContainerInfo": "分单订舱预配箱信息",
        "containerTypeAndQuantity": "箱型箱量",
    },
    /*估价单*/
    "estimate": {
        "estimateSearch": "估价单查询",
        "estimateNo": "估价单号",
        "containerNo": "箱号",
        "applyDateStart": "申请日期从",
        "applyDateEnd": "申请日期到",
        "factFinalDateStart": "完成日期从",
        "factFinalDateEnd": "完成日期到",
        "repairStatus": "维修状态",
        "estimateExcelImport": "修箱估价单导入",
        "estimateExcelImportNew": "修箱估价单导入(新)",
        "estimatePicturesBatchImport": "箱损图片导入",
        "completedPicturesBatchImport": "修妥图片导入",
        "senderCode": "发送方代码",
        "portAndDepot": "港口/堆场",
        "vvl": "船名/航次",
        "vesselCode": "船名",
        "voyageNo": "航次",
        "containerType": "箱型",
        "blNo": "提单号",
        "portCode": "港口代码",
        "depotCode": "堆场代码",
        "applyDate": "申请日期",
        "picStatus": "箱损图片导入状态",
        "completePicStatus": "修妥图片导入状态",
        "receive": "收费",
        "refund": "退费",
        "factFinalDate": "实际完成日期",
        "remark": "备注",
        "approveDate": "审核日期",
        "approver": "审核人",
        "versionStatus": "版本",
        "updatedDtmLoc": "最后更新时间",
        "paymentBillFlag": "付费对账",
        "estimateAccount": "申请总费",
        "approveAccount": "最终价",
        "currency": "币种",
        "thirdCustomerChargeImport": "第三方收退费导入",
        "estimateUpload": "修箱估价单上传",
        "estimateUploadNew": "修箱估价单上传（新）",
        "uploadTips": "（部分浏览器可能不支持拖拽文件上传，请使用谷歌浏览器）",
        "uploadTips1": "【注】估价单上传仅支持 *.xls,*.xlsx 格式的EXCEL文件；修箱图片支持 .jpg,.jpeg,.png,.bmp,.gif 格式，需按照要求压缩为 .zip 格式的压缩文件后统一上传，压缩文件结构及命名要求请点击底部\"文件上传说明\"",
        "picUploadTips": "修箱图片文件上传说明",
        "picUploadTips1": "文件上传说明",
        "estUpload": "估价单上传",
        "picUpload": "图片上传",
        "picBatchUpload": "箱损图片批量导入",
        "completePicBatchUpload": "修妥图片批量导入",
        "picBatchUploadTips": "【注】修箱图片支持 .jpg,.jpeg,.png,.bmp,.gif 格式，需按照要求压缩为 .zip 格式的压缩文件后统一上传，压缩文件格式及命名要求请点击底部\"文件上传说明\"",
        "picBatchUploadTips1": "修箱图片文件批量上传说明",
        "uploadFiles": "上传文件",
        "uploadCompleted": "导入完成",
        "pleaseSelectFiles2Upload": "请选择上传文件！",
        "wrongEstimateFormat": "上传文件格式错误!只支持上传 *.xls 和 *.xlsx 文件",
        "wrongPicFormat": "上传文件格式错误!只支持上传 *.zip 文件",
        "uploading": "导入中，请稍候...",
        "excelTemplateDL": "估价单导入模板下载",
        "excelTemplateDLNew": "（新）估价单导入模板下载",
        "uploadSizeLimit": "文件【{fileName}】大小（{fileSize}）超过最大限制，单个文件大小不能超过20M！",
        "finishValidate": "估价单【箱号={containerNo}】，{fieldName}不能为空！",
        "finishValidate2": "验证出错！估价单【箱号={containerNo}】修箱完成时间早于审批时间，是否确认保存？",
        "finishComfirm": "修箱完成的估价单审批费用将用于财务挂账，请确认是否完成？",
        "failed2finish": "估价单【{estimateNo}】非已审批状态，不可设置修箱完成，请重新选择；",
        "failed2finish2": "箱号【{containerNo}】未上传修妥图片，不可设置修箱完成，请重新选择；",
        "repairFinishButton": "修箱完成",
        "batchFinish": "批量修箱完成",
        "batchFinishNote": "【注】实际完成日期及备注列内容支持表格内单独设置（鼠标双击指定单元格即可启动编辑），或在底部输入实际完成日期和备注内容，将对上方表格中所有记录适用；",
    },
    "estimateDetails": {
        "estimatePicturesBatchUpload": "箱损图片上传",
        "completedPicturesBatchUpload": "修妥图片上传",
        "index": "序号",
        "estimateDetails": "估价单基本信息",
        "senderCode": "发送方代码",
        "portCodeAnddepotCode": "港口/堆场",
        "officeCode": "代理",
        "applyDate": "申请日期",
        "estimateNo": "估价单号",
        "containerNoAndcontainerType": "箱号/箱型",
        "containerNo": "箱号",
        "containerType": "箱型",
        "repairType": "维修类型",
        "preFinalDate": "要求完成日期",
        "movement": "空重状态",
        "vesselCodeAndvoyageNo": "船名/航次",
        "blNo": "提单号",
        "recvFlag": "是否收费",
        "currency": "币种",
        "discount": "折扣",
        "repairStatus": "维修状态",
        "manufacture": "生产商",
        "onhiredDate": "租箱日期",
        "party": "维修方",
        "updatedByUser": "最后更新人员",
        "updatedDtmLoc": "最后更新时间",
        "maker": "冷机类型",
        "modelNo": "冷机型号",
        "warrantyPeriod": "保修期",
        "estBodyMachines": {
            "estBodyInfo": "箱体参数信息",
            "estBodyMachineInfo": "冷机参数信息",
            "componentCode": "构件",
            "repairLocationCode": "部位",
            "damageCode": "损坏",
            "repairCode": "维修",
            "materialCode": "材料",
            "partNo": "冷机配件号",
            "length": "长度",
            "width": "宽度",
            "quantity": "数量",
            "loborRate": "人工费率",
            "workHours": "工时",
            "laborCost": "人工费",
            "materialRate": "材料费率",
            "materialCost": "材料费",
            "estimateAccount": "申请费用",
            "approveAccount": "审批费用",
            "receiveAccount": "收取费用",
        },
        "labTotal": "总工费",
        "matTotal": "总材料费",
        "applyTotal": "申请总费",
        "approveTotal": "审批总费",
        "applyRemark": "申请备注",
        "approveRemark": "审批备注",
        "receiveRemark": "收费备注",
        "estContainerPic": {
            "estContainerPicInfo": "箱损图片信息",
            "estCompleteContainerPicInfo": "修妥图片信息",
            "index": "序号",
            "fileName": "文件名",
            "isRepairCompleted": "图片类型",
            "createdDtmLoc": "上传日期",
            "remark": "备注",
            "picPreview": "图片预览",
            "tips": " 未获取到图片信息",
            "damage": "箱损",
            "complete": "修妥",
            "wrongPicFormat": "上传图片格式错误!只支持上传 *.jpg,*.jpeg,*.png,*.bmp,*.gif 文件",
            "uploadSizeLimit": "文件【{fileName}】大小（{fileSize}）超过最大限制，单个文件大小不能超过5M！",
            "deletePicConfirm": "是否确认删除图片 {fileName}？确认并点击底部保存按钮后则删除操作不可取消",
            "deleteConfirm": "是否确认删除选中图片？确认并点击底部保存按钮后则删除操作不可取消",
        },
        "estimateCustomerCharge": {
            "estimateCustomerChargeInfo": "第三方收费信息",
            "index": "序号",
            "receiveDate": "收费日期",
            "receiveAmount": "收费金额",
            "currency": "币种",
            "approverAmount": "审批金额",
            "approverDate": "审批时间",
            "approver": "审批人",
            "refundDate": "退费日期",
            "refundAmount": "退费金额",
            "remark": "收退费说明",
        },
        "estimateDeleteConfirm": "删除估价单，将级联删除减免记录，是否确认删除?",
        "saveEstimateFirst": "请先保存估价单信息！",
    },
    /*第三方收退费*/
    "thirdPartyCharge": {
        "thirdPartyChargeSearch": "第三方收退费查询",
        "index": "No.",
        "estimateNo": "估价单号",
        "containerNo": "箱号",
        "depotCode": "堆场",
        "createdDtmLoc": "创建时间",
        "crateTimeStart": "创建时间从",
        "crateTimeEnd": "创建时间到",
        "customerChargeExcelImport": "第三方收退费导入",
        "customerChargeUpload": "第三方收退费上传",
        "senderCode": "发送方代码",
        "receiveDate": "收费日期",
        "receiveAmount": "收费金额",
        "currency": "币种",
        "refundDate": "退费日期",
        "refundAmount": "退费金额",
        "remark": "收退费说明",
        "actualAmount": "实际金额",
        "uploadTips": "【注】第三方收退费上传仅支持 *.xls 和 *.xlsx 格式",
        "validateInfo": "校验结果",
        "validating": "导入中，正在进行业务校验...",
    },
    /*费用信息查询*/
    "confirmFreight": {
        "title": "费用信息查询",
        "no": "序号",
        "vvl": "船名/航次",
        "vesselCode": "船舶代码",
        "vesselName": "船舶",
        "voyageNo": "航次",
        "voyageLeg": "航段",
        "year": "年份",
        "settleMonth": "结算月",
        "saillingDate": "开航时间",
        "sailingTimeStart": "开航时间从",
        "sailingTimeEnd": "开航时间到",
        "blNo": "提单号",
        "charge": "费项",
        "chargeCode": "费用代码",
        "chargeName": "费用名称",
        "chargeNameCn": "费用名称CN",
        "currency": "币种",
        "isReconciliated": "是否对账",
        "voyageInfo": "航次信息",
        "amountTotal": "总金额",
        "freightInfo": "费用明细",
        "caculateQty": "计价数量",
        "caculateUnit": "计价单位",
        "amount": "应收金额",
        "payer": "应收客户代码",
        "customerName": "应收客户名称",
        "customerNameCn": "应收客户名称(CN)",
        "payModel": "付费方式",
        "today": "今天",
        "yesterday": "昨天",
        "beforeOneWeek": "一周前",
        "button": {
            "billGenerateBtn": "生成对账单",
            "exportTableDataBtn": "导出数据"
        },
        "message": {
            "searchValidate": "船名/航次与年份/结算月条件不能同时为空！请输入至少一项进行查询",
            "searchblNoValidate": "提单号查询条件不可超过{length}字符！",
            "billGenerateValidate": "请选择费用明细！",
            "freightStatusValidate": "勾选费用中包含已对账的费用，请重新选择！",
        },
        "costInformationQuery": "费用信息查询",
        "isReconcile": "是否对账",
    },
    "invoiceApplication": {
        "title": "发票信息查询",
        "invoiceNo": "发票号",
        "invoiceHeader": "发票抬头",
        "issuedDateFrom": "开票日期从",
        "issuedDateTo": "开票日期到",
        "currency": "发票币别",
        "totalAmount": "合计金额(小写)",
        "isCancelled": "发票状态",
        "invoiceType": "发票类型",
        "BusinessNo": "提(运)单号",
        "ledgerCompNo": "对账单号",
        "hasNoExpressNumber": "无快递单号",
        "delete": "删除",
        "submit": "提交",
        "issuedDate": "开票日期",
        "trackingNumber": "快递单号",
        "payerName": "付款单位",
        "quoteCurrency": "原币",
        "quoteAmount": "原币金额",
        "isInvoice": "是否电票",
        "relationInvoiceNo": "关联发票号",
        "relationIssuedDate": "关联开票日期",
        "feeDetail": "明细",
        "card": "卡片",
        "table": "表格",
        "remark": "备注",
        "invoiceDownload": "发票下载",
        "exportData": "导出数据",
        "operation": "操作",
        "SuccessfullySubmitted":"提交成功"
    },
    "invoiceDetails": {
        "invoiceBaseInfo": "发票基本信息",
        "invoiceNo": "发票号",
        "accountNo": "银行账号",
        "bankName": "开户银行",
        "invSettleOffice": "结算公司",
        "invoiceHeader": "发票抬头",
        "vesselCodeVoyage": "船名/航次",
        "businessNo": "提(运)单号",
        "blNo": "提单号",
        "issuedDate": "开票日期",
        "etd": "开航日",
        "eta": "到港日",
        "electronicInvoiceFlag": "电子发票",
        "invoiceType": "发票类型",
        "portLoadName": "起运港",
        "portDiscName": "卸货港",
        "portDestName": "目的港",
        "taxVersionNum": "税务版本号",
        "quoteCurrency": "原币",
        "quoteAmount": "原币金额",
        "payerBank": "开户行",
        "payerAccountNo": "账号",
        "payerContacts": "联系人",
        "payerTel": "电话",
        "customerEmail": "客户email",
        "payerBillingAddress": "开票地址",
        "businessRegisterNo": "工商登记号",
        "taxRegisterNo": "税务登记号",
        "quantity": "数量",
        "unitPrice": "单价",
        "currencyType": "币别",
        "settleAmount": "开票金额",
        "remark": "备注",
        "totalAmountB": "合计金额(大写)",
        "totalAmountS": "合计金额(小写)",
        "rateMonth": "月份",
        "exchangeRate": "月度汇率",
        "invoiceBLInfo": "发票提单号",
        "ledgerCompNo": "对账单号",
        "vesselCode": "船舶代码",
        "voyageNo": "航次",
        "voyageLeg": "航段",
        "primeCurrencyCode": "原币",
        "primeCurrencyValue": "原币金额",
        "ledgerPartnerName": "客户名称",
        "officeId": "结算公司",
        "invoiceStatus": "开票状态",
        "allocatedStatus": "核销状态",
        "expenseDetails": "费用明细",
        "expenseCode": "费用代码",
        "expenseName": "费用名称",
        "invoiceAmount": "本次开票金额",
        "rateToInvoice": "汇率",
        "invoicablePrimeCurrencyValue": "可开票原币金额",
        "invoicedPrimeCurrencyValue": "已开票原币金额",
        "businessSeal": "企业签章",
        "receiver": "领用人",
        "applicatEmail": "申请人email",
        "finDeliveryAddress": "财务快递地址",
        "checkedName": "复核人/制单人",
        "submit": "提交",
        "returnApply": "申请退回",
        "chargingContent":"收费内容",
        "customerName": "客户名称",
        "carriedForward":"对账单正在结转财务...",
        "invoiceSave":"发票保存中，请稍候...",

    },
    /*对账单信息查询*/
    "billsManagement": {
        "title": "对账单信息查询",
        "vvl": "船名/航次",
        "soaNo": "对账单号",
        "blNo": "提单号",
        "confirmStatus": "确认状态",
        "confirmDateStart": "确认时间从",
        "confirmDateEnd": "确认时间到",
        "createTimeStart": "创建时间从",
        "createTimeEnd": "创建时间到",
        "invoiceStatus": "开票状态",
        "balanceUnitsEn": "客户名称",
        "balanceUnitsCn": "客户名称(CN)",
        "currency": "币种",
        "amount": "金额",
        "createdByUser": "创建人",
        "createdDtmLoc": "创建时间",
        "confirmByUser": "确认人",
        "confirmDate": "确认时间",
        "remark": "备注",
        "button": {
            "confirmBtn": "账单确认",
            "cancelConfirmBtn": "取消确认",
            "invoiceBtn": "申请开票",
            "billsDownload": "下载对账单",
            "pdfDownload": "PDF下载",
            "excelDownload": "Excel下载",
        },
        "message": {
            "noDetails":"请选择要删除的费用明细!",
            "removeExpense":"是否确认将选中的费用从当前对账单费用明细中移除？",
            "cannotConfirmAgain":"当前对账单为确认状态，无需再次确认！",
            "confirmSuccess":"确认成功!",
            "cannotCancelConfirm":"当前对账单为未确认状态，不可取消确认！",
            "cannotInvoice":"当前对账单非已确认状态，不可开票，请先确认！",
            "invoice":"是否确认开票？",
            "generatingInvoice":"正在生成发票内容，请稍候...",
            "cannotDeleted":"当前对账单非未确认状态，不可删除！",
            "deleteFailed":"删除失败",
            "deleteSOA":"是否确认删除当前对账单？",
            "leastOne":"船名/航次与年份/月份条件不能同时为空！请输入至少一项进行查询",
            "notSelected":"未选择费用明细！",
            "saveFailed":"保存失败",
            "savedSuccessfully":"保存成功",

        }
    },
    /*对账单基本信息*/
    "billsDetails": {
        "title": "对账单基本信息",
        "index": "序号",
        "soaNo": "对账单号",
        "balanceUnits": "结算单位代码",
        "balanceUnitsEn": "结算单位",
        "balanceUnitsCn": "结算单位(CN)",
        "createdByUser": "创建人",
        "createdDtmLoc": "创建时间",
        "confirmFlag": "确认状态",
        "invoiceFlag": "开票状态",
        "remark": "备注",
        "tableCurrencyAmountInfo": {
            "title": "应收金额",
            "note": "(按币种合计)",
            "currency": "币种",
            "amount": "金额"
        },
        "tableVoyageInfo": {
            "title": "航次信息",
            "vesselCode": "船舶代码",
            "vesselName": "船舶名称",
            "voyageNo": "航次",
            "voyageLeg": "航段",
        },
        "tableFreightReceivableInfo": {
            "title": "费用明细",
            "index": "序号",
            "saillingDate": "开航日",
            "vesselCode": "船舶代码",
            "vesselName": "船舶名称",
            "voyageNo": "航次",
            "voyageLeg": "航段",
            "blNo": "提单号",
            "chargeCode": "费项代码",
            "chargeName": "费项名称",
            "currency": "币种",
            "amount": "金额",
            "payerNameCn": "客户名称(CN)",
            "payerName": "客户名称",
            "caculateQty": "计价数量",
            "containerType": "箱型代码",
            "caculateUnit": "计价单位",
            "payModel": "付费方式",
            "cargoTypeCode": "货类",
            "agreementNo": "协议号",
        },
        "tableBLNoInfo": {
            "index": "序号",
            "blNo": "提单号",
        },
        "freightAddDialog": {
            "title": "添加费用",
            "vesselCode": "船舶代码",
            "vesselName": "船舶名称",
            "voyageNo": "航次",
            "voyageLeg": "航段",
            "blNo": "提单号",
            "sailingTimeStart": "开航日从",
            "sailingTimeEnd": "开航日到",
            "year": "年份",
            "month": "月份",
            "currency": "币种",
            "chargeCode": "费项",
        },
        "button": {
            "addCostBtn": "添加费用",
            "removeCostBtn": "移除费用",
            "ConfirmBtn": "账单确认",
            "cancelConfirmBtn": "取消确认",
            "invoiceBtn": "申请开票",
            "billsDownload": "下载对账单",
            "billsDownloadPdfBtn": "PDF下载",
            "billsDownloadExcelBtn": "Excel下载",
            "searchBtn": "查询"
        },
        "pdfDownLoad":"PDF下载成功！",
        "excelDownLoad":"EXCEL下载成功！",
        "produceBill":"保存成功！生成对账单：",
        "copyBillNo":"拷贝对账单号",
    },
    /*信息*/
    "message": {
        "loginFirst": "请先登录",
        "failMsg": "操作失败!",
        "account": "请输入账号",
        "passWord": "请输入密码",
        "logoutMsg": "当前已退出登录!",
        "loadingPortValidate": "请选择装货港",
        "dischargePortValidate": "请选择卸货港",
        "pleaseSelect2preView": "请选择要预览的提单记录",
        "pleaseSelect2operate": "请选择要操作的记录",
        "pleaseSelect2Edit": "请选择要编辑的订舱记录",
        "pleaseSelect2Send": "请选择要发送的订舱记录",
        "pleaseSelect2Copy": "请选择要拷贝的订舱记录",
        "pleaseSaveFirst": "当前页面数据未保存，请先保存",
        "preContainerDeleteConfirm": "是否确定删除当前选中的订舱预配箱数据？",
        "imoDeleteConfirm": "是否确定删除最后一行危险品数据？",
        "reeferDeleteConfirm": "是否确定删除最后一行冷箱数据？",
        "akDeleteConfirm": "是否确定删除最后一行特种箱数据？",
        "containerDeleteConfirm": "是否确定删除集装箱号:",
        "bkNoNotNull": "订舱号不能为空!",
        "blNoNotNull": "提单号不能为空!",
        "agreementNoNotNull": "船开前协议号不能为空!",
        "porNotNull": "接货地不能为空!",
        "delNotNull": "目的地不能为空!",
        "transportationTermsNotNull": "运输条款不能为空!",
        "paidTypeNotNull": "付费方式不能为空!",
        "applicationUnitNotNull": "询价单位不能为空!",
        "deliveryDocumentMethodNotNull": "提单类型不能为空!",
        "deliveryDocumentPlaceNotNull": "签单地点不能为空!",
        "hsCodeNotNull": "HS CODE不能为空!",
        "porNameNotNull": "接货地描述不能为空!",
        "polNameNotNull": "装货港描述不能为空!",
        "podNameNotNull": "卸货港描述不能为空!",
        "delNameNotNull": "目的地描述不能为空!",
        "classTypeNotNull": "【危险品信息】第{index}行：IMO Class 不能为空！",
        "unSeriseNoNotNull": "【危险品信息】第{index}行：UN No. 不能为空！",
        "packageDescNotNull": "【危险品信息】第{index}行：包装种类不能为空！",
        "packageCodeNotNull": "【危险品信息】第{index}行：包装类型不能为空！",
        "propertyNotNull": "【危险品信息】第{index}行：运输品名不能为空！",
        "componentDescNotNull": "【危险品信息】第{index}行：化学品名不能为空！",
        "emergencySeqNotNull": "【危险品信息】第{index}行：应急措施编号不能为空！",
        "rateBaseNotNull": "【冷箱信息】第{index}行：单位不能为空！",
        "temperatureNotNull": "【冷箱信息】第{index}行：温度不能为空！",
        "intakeNumNotNull": "【冷箱信息】第{index}行：通风口不能为空！",
        "consigneeAndNotifierTelNotNull": "目的地HAIPHONG 单证要求：需提供收货人及通知人联系电话（可不显示在提单上）",
        "noBkContainer": "无法发送,请录入集装箱信息!",
        "searching": "查询中...",
        "saving": "保存中...",
        "sending": "发送中....",
        "copying": "拷贝中，请稍候....",
        "downloading": "下载中，请稍候....",
        "copySuccessful": "拷贝完成",
        "ydhTxtSearch": "请选择查询方式并输入提单号或箱号开始查询",
        "enterNo": "请输入查询单号",
        "selectType": "请选择查询类型",
        "selectEntity": "请选择查询主体",
        "notSupportMulti": "亲爱的客户,本系统暂时不支持多个箱号或多个提单号查询",
        "charLengthLimitMsg": "输入字符不得超过{length}字节*{row}行，超过部分请用*接在货描下面",
        "charLengthLimitMsg2": "输入字符不得超过{length}字节*{row}行",
        "cannotMakeBL": "仅订舱状态为订舱确认、锁定或解锁状态的订舱信息可创建提单，请重新选择",
        "noBkPreContainer": "请添加订舱预配箱信息!",
        "noCargoTypeCode": "【订舱预配箱】第{index}行：货类不能为空!",
        "noCargoTypeCode2": "【集装箱信息】第{index}行：货类不能为空!",
        "illegalCargoTypeCode": "【集装箱信息】第{index}行：订舱预配箱中不存在货类{cargoType}!",
        "containerManager": "【集装箱信息】第{index}行：箱主不能为空!",
        "containerWeight": "【集装箱信息】第{index}行：箱皮重不能为空!",
        "containerNo": "【集装箱信息】第{index}行：箱号不能为空!",
        "cargoDesc": "【集装箱信息】第{index}行：{serviceLineCode} 航线下箱信息中货名不能为空!",
        "hsCode": "【集装箱信息】第{index}行：{serviceLineCode} 航线下箱信息中 HS CODE不能为空!",
        "classType": "【集装箱信息】第{index}行：{serviceLineCode} 航线下全危箱 IMDG CLASS 不能为空!",
        "unSerialNo": "【集装箱信息】第{index}行：{serviceLineCode} 航线下全危箱 UN No.不能为空!",
        "reeferTemp": "【集装箱信息】第{index}行：{serviceLineCode} 航线下冻货箱 温度 不能为空!",
        "containerType": "【集装箱信息】第{index}行：箱型不能为空!",
        "illegalContainerType": "【集装箱信息】第{index}行：订舱预配箱中不存在箱型{containerType}!",
        "illegalContainerManager": "【集装箱信息】第{index}行：箱主只能是SOC或ZGL",
        "containerManagerMismatchSOC": "当前提单已勾选 SOC 标记，以下箱号：{containerNos} 已自动更新箱主为 {containerManager}",
        "containerManagerMismatchZGL": "当前提单未勾选 SOC 标记，以下箱号：{containerNos} 已自动更新箱主为 {containerManager}",
        "sealNo1": "【集装箱信息】第{index}行：铅封号1不能为空!",
        "containerNoDuplicated": "第{index}行：箱号 {containerNo} 重复录入,请检查!",
        "containerNoNoMatch": "第{index}行：箱号 {containerNo} 不符合箱号国际规则",
        "hsCodeOverLength": "【集装箱信息】第{index}行：HS CODE长度不能超过{maxLength}个字符!",
        "validateQuantity": "货物信息中件数({quantity1})与箱信息中件数({quantity2})不相匹配!",
        "validateWeight": "货物信息中重量({weight1})与箱信息中重量({weight2})不相匹配!",
        "validateSize": "货物信息中尺寸({size1})与箱信息中尺寸({size2})不相匹配!",
        "addDgInfoMsg": "存在货物类型为【全危】的订舱预配箱信息，请录入危险品信息",
        "addDgPreContainerInfoMsg": "请先录入对应货物类型为【全危】的订舱预配箱信息",
        "addRfInfoMsg": "存在货物类型为【冻货】的订舱预配箱信息，请录入冷箱信息",
        "addRfPreContainerInfoMsg": "请先录入对应货物类型为【冻货】的订舱预配箱信息",
        "clearDgInfo": "请先将危险品记录清空!",
        "clearRfInfo": "请先将冷箱记录清空!",
        "blSendConfirm": "更改一次产生一次一票200CNY改单费，请确认此更改是否被船公司接受，提单已签发请及时换签提单",
        "canNotDownload": "装货港 {pol} 的订舱SO暂不支持下载",
        "packingListCanNotDownload": "装货港 {por} ,无法下载南沙下货纸",
        "noSaveAndClose": "是否确定取消?取消将放弃本次的修改",
        "parseError": "【数据解析异常】 ",
        "noData2Parse": "未解析到数据",
        "bookingNotConfirm": "该舱单非订舱确认状态,无法下载SO及下货纸!",
        "specialLocked": "当前无法录入危险品/冷箱等特殊设置信息！",
        "containerWeightNotZero": "【集装箱信息】第{index}行：箱皮重不能为0!",
        "pleaseEnterqueryConditions": "请输入完整的船名及航次条件！",
        "pleaseSelecte2Copy": "请选中要复制的主单订舱预配箱信息！",
        "noSelectedHBL": "未选中分单，无法复制！",
        "pleaseSelectHBL2Delete": "请选择要删除的分单记录！",
        "noSelectedHBLPreContainer2Delete": "未选择要删除的订舱预配箱记录！",
        "hblDeleteConfirm": "是否确定删除分单【{hbl}】?",
        "hblPreContainerDeleteConfirm": "是否确定删除【{containerType}】订舱预配箱信息？",
        "saveSucceed": "保存成功！",
        "cannotLT2HBLS": "拆单时不能少于两条分单信息！",
        "existsDuplicatedBlNo": "分单中存在相同的提单号，请检查！",
        "existsDuplicatedBkNo": "分单中存在相同的订舱号，请检查！",
        "hblNoBkPreContainer": "分单【{hbl}】未录入订舱预配箱信息，无法保存！",
        "quantityInconsistent": "分单合计制单件数【{quantityTotal}】与主单件数【{quantity}】不一致,请检查！",
        "weightInconsistent": "分单合计制单重量【{grossWeightTotal}】与主单重量【{cargoGrossWeight}】不一致,请检查！",
        "sizeInconsistent": "分单合计制单尺寸【{quantityTotal}】与主单尺寸【{cargoSize}】不一致,请检查！",
        "noMatchCannotSplite": "主分单的航名、航次、卸货港和发货人要一致才能进行拆单！",
        "hblInfoNoBlNo": "【分单信息】第{index}行：提单号不能为空!",
        "hblInfoNoBkNo": "【分单信息】第{index}行：订舱号不能为空!",
        "hblInfoNoCargoShippingMark": "【分单信息】第{index}行：唛头不能为空!",
        "hblInfoNoCargoQuantity": "【分单信息】第{index}行：制单件数不能为空，且不能为0！",
        "hblInfoNoCargoGrossWeight": "【分单信息】第{index}行：制单重量不能为空，且不能为0！",
        "hblInfoNoCargoSize": "【分单信息】第{index}行：制单尺寸不能为空，且不能为0！",
        "cancelSpliteNote": "取消拆单同时是否要删除分单 {hbls} ？",
        "chooseHBL2SetMBL": "请在下方分单信息表格中选中要设置为主单的分单记录！",
        "cancelCombineNote": "请选中要取消并单的主单记录！",
        "cancelCombineConfirm": "是否确定取消并单？",
        "removeCheckedHBLConfirm": "是否确定移除勾选的分单？",
        "noSelectedHBL2Delete": "请先勾选要移除的分单记录！",
        "validateFileTypeFailed": "（{fileName}）上传失败！只支持上传 *.pdf, *.png, *.jpg, *.jpeg 格式",
        "guaranteeUploadSizeLimit": "文件【{fileName}】大小（{fileSize}）超过最大限制，单个文件大小不能超过5M！",
        "guaranteeUpload413Error": "文件【{fileName}】上传失败！文件过大，服务器无法处理。请确保文件大小不超过5M，或联系管理员增加服务器上传大小限制。",
        "guaranteeUploadValidationFailed": "以下文件校验不通过，请修正后重新上传：",
        "guaranteeUploadValidationTitle": "文件校验失败",
        "guaranteeDeleteConfirm": "此操作将永久删除该保函, 是否继续?",
        "guaranteeDeleteSucceed": "删除成功！",
        "noGuaranteeFilesUploaded": "未上传保函",
        "noDataSelected": "您当前未选择任何记录",
        "blBatchDownloadFailed": "【{blNo}】下载失败！可尝试单条下载",
        "cargoInformationSizeNotNull":"货物信息中,尺寸不能为空!",
        "enterAtLeastOne": "请至少输入一个条件进行查询！",
        "invoiceDownloadErrorTitle":"发票暂未上传附件",
        "invoiceNotDelete":"当前发票已经提交，无法删除！如确定要删除，请先申请退回当前发票",
        "deleteCurrentInvoice":"是否确认删除当前发票？（若存在实收登记数据，发票删除同时会自动删除对应的实收登记数据）",
        "ConfirmSubmission":"是否确认提交当前发票申请？提交申请后发票信息不可修改",
        "SetTomorrow":"当前时间已超过北京时间16:00，是否将开票日期设置为明天？",
        "invoiceDeleteConfirm": "当前发票已经提交，无法删除！如确定要删除，请先申请退回当前发票",
        "invoiceDeleteConfirmTwo":"是否确认删除当前发票？（若存在实收登记数据，发票删除同时会自动删除对应的实收登记数据）",
        "invoiceSubmitConfirm":"是否确认提交当前发票申请？提交申请后发票信息不可修改",
        "invoiceNowHourConfirm":"当前时间已超过北京时间16:00，是否将开票日期设置为明天？",
        "invoiceReturn":"当前发票已提交，是否申请退回？",
        "returnApply":"已发送退回申请！",
        "copyBill":"对账单号已复制，可直接在对账单管理页面粘贴对账单号进行查询",
        "copyBillFailed": "拷贝失败！请尝试手动拷贝",
        "invoiceSubmitted": "当前发票已经提交，不可重复提交！",
        "invoiceNotAllowed2Commit": "存在已提交的发票，不可重复提交，请重新选择！",
        "applicationUnitLengthWarn": "询价单位填写字符长度超过限制！当前输入为{charLength}位字符（最多允许输入20位字符，仅支持英文字符）",
        "grossWeightLessThanNetWeight": "【货物信息】毛重(KG)不能小于净重(KG)!",
    },
    /*用户中心*/
    "userCenter":{
        /*个人信息*/
        "personalInfo":{
            "personalInfo":"个人信息",
            "changePassword":"修改密码",
            "modifyInformation":"修改信息",
            "currentPassWord":"当前密码",
            "newPassword":"新的密码",
            "confirmPassword":"确认密码",
            "companyCode":"客户代码",
            "companyNameCn":"客户名称(CN)",
            "companyName":"客户名称(EN)",
            "newPasswordTip":"请输入新密码",
            "confirmPasswordTip":"请再次输入密码",
            "confirmPasswordWarn":"两次输入密码不一致!",
            "currentPassWordTip":"请输入当前密码",
            "resetPassword":"重置密码",
        },
    },
    "vxe": {
        "loading": {
            "text": "数据加载中..."
        },
        "modal": {
            "close": "关闭",
        },
        "pager": {
            "prevPage": "上一页",
            "nextPage": "下一页",
            "goto": "前往",
            "nextJump": "向后跳页",
            "prevJump": "向前跳页",
            "pageClassifier": "页",
            "pagesize": "{0}条/页",
            "total": "共{0}条记录",
        },
        "table": {
            "emptyText": "暂无数据",
            "allTitle": "全部",
            "sortAsc": "升序",
            "sortDesc": "降序",
            "expFilename": "{0}"
        },
        "export": {
            "expTitle": "导出数据",
            "expNamePlaceholder": "请输入文件名",
            "expName": "文件名",
            "expType": "保存类型",
            "expMode": "选择数据",
            "expColumn": "选择字段",
            "expOpts": "参数设置",
            "expCurrentColumn": "全部字段",
            "expOptHeader": "表头",
            "expHeaderTitle": "是否需要表头",
            "expOptFooter": "表尾",
            "expOptOriginal": "源数据",
            "expOptColgroup": "分组表头",
            "expOptMerge": "合并",
            "expOptUseStyle": "样式",
            "expOptAllExpand": "展开层级",
            "expCancel": "取消",
            "expConfirm": "导出",
            "expFooterTitle": "是否需要表尾",
            "expOriginalTitle": "是否导出为源数据",
            "expColgroupTitle": "如果存在，则支持带有分组结构的表头",
            "expMergeTitle": "如果存在，则支持带有合并结构的单元格",
            "expUseStyleTitle": "如果存在，则支持带样式的单元格",
            "expAllExpandTitle": "如果存在，则支持将带有层级结构的数据全部展开",
            "printTitle": "打印数据",
            "expSheetName": "标题",
            "expSheetNamePlaceholder": "请输入标题",
            "expPrint": "打印",
            "types": {
                "csv": "(*.csv)",
            },
            "modes": {
                "current": "当前数据(当前页的数据)",
                "selected": "选中数据(当前页选中的数据)",
            },
        },
        "toolbar": {
            "print": "打印",
            "custom": "列设置",
            "customAll": "全部",
            "customConfirm": "确认",
            "customRestore": "还原",
            "zoomIn": "全屏",
            "zoomOut": "退出全屏",
        },
        "error": {
            "reqProp": "reqProp"
        }
    },
    "demurrageRate": {
        "bannerTitle": "滞箱费费率文件下载中心",
        "bannerDescription": "本页面提供国内外各地区滞箱费费率文件的PDF下载服务，所有文件均为官方发布版本，如有疑问可联系中谷客服人员",
        "domesticRegion": "国内地区",
        "foreignRegion": "国外地区",
        "fileSize": "文件大小：",
        "publishDate": "发布时间：",
        "downloadComplete": "下载完成",
        "searchPlaceholder": "请输入国家或地区名称进行搜索",
        "searchButton": "搜索"
    }
};


export default zh;